<div class="no-access-container">
  <div class="no-access-content">
    <h1 class="error-code">Access Restricted</h1>
    <h2 class="error-message">You don’t have access to this page</h2>
    <p class="error-description">
      Please reach out to
      <a href="mailto:rahul.balakrishnan@cummins.com">Rahul Balakrishnan</a> or
      <a href="mailto:pallavi.sonker@cummins.com">Pallavi Sonker</a> for access related issues.
    </p>
  </div>
</div>
